import React from 'react';
import { Dialog,Box, Avatar} from '@mui/material';
import { styled } from '@mui/material/styles'; 
import BtnPrimary from "./PrimaryButton";
import GreenTick from "../assets/images/green-success.png";
import { useNavigate } from 'react-router';

import { displayFont } from "../theme";
import { tokens } from "../theme";
const TextBox = styled(Box)({
    display: "block",
});

function SaveDialog({open, onClose, redirectLink, resendInfo}) {
  
  const navigate = useNavigate();

  const handleOk = () =>{
    resendInfo?onClose():navigate(redirectLink);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0 4px 12px -4px rgba(42,29,34,0.16)",
          padding: "1.5rem",
          display:"flex",
          flexDirection:"column",
          alignItems:"center",
          gap: "1.5rem"
        }
      }}
    >
        
            <Avatar src={GreenTick} alt="icon" sx={{height:"3rem", width:"3rem"}}/>
            <TextBox sx={{fontWeight: 600, fontFamily: displayFont, fontSize: "1.25rem", lineHeight: 1.3}}>
                Success!!
            </TextBox>
            <TextBox sx={{fontSize: "1rem", lineHeight: 1.7, color: tokens.textMuted }}>
              {
                resendInfo?`Onboarding Invitation has been resent successfully to`:
                " Your changes have been saved successfully"
              }
              <TextBox sx={{fontSize: "1rem", lineHeight: 1.7, color: "#8C3B5E", textAlign:"center" }}>
                {resendInfo ? resendInfo : null}
              </TextBox>
            </TextBox>
           <BtnPrimary onClick={handleOk} sx={{width:"6.25rem", borderRadius: '8px' }}>
                 Ok
           </BtnPrimary>
    </Dialog>
  );
}

export default SaveDialog;

